
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/rent-cruncher",
      function () {
        return require("private-next-pages/tools/rent-cruncher/index.tsx");
      }
    ]);
  